import PageHero from "@/components/PageHero";
import ClientsSection from "@/sections/ClientsSection";
import CTABlock from "@/components/CTABlock";

export default function Work() {
  return (
    <div data-testid="work-page">
      <PageHero
        testId="work-page-hero"
        label="Selected Clients"
        title="Businesses we have"
        accent="supported."
        subtitle="Fortuna Strive has worked with businesses across consulting, education, home services, local services, technology, and hospitality."
      />
      <ClientsSection withHeader={false} />
      <CTABlock />
    </div>
  );
}
